import { useCallback, useEffect, useState } from "react";
import {
  PaymentPurposeCode,
  PaymentTypeCode,
  rechargeChannelsCode,
} from "project-config/constants";
import { useTranslation } from "react-i18next";
import Pay01 from "@/assets/images/pay-01.png";
import Pay02 from "@/assets/images/pay-02.png";
import Pay03 from "@/assets/images/pay-03.png";
import Pay04 from "@/assets/images/pay-04.png";
import Pay05 from "@/assets/images/pay-05.png";
import Pay06 from "@/assets/images/pay-06.png";
import Alipay from "@/assets/images/pay-alipay1.png";
import Paypal from "@/assets/images/paypal.png";
import Wechat from "@/assets/images/pay-wechat1.png";
import Stripe from "@/assets/images/pay-stripe1.png";
import { useGlobalStore } from "@/store/GlobalStore";
import { initVerifyRechargeInfo, useFoxTopUpStore } from "../../store";
import { FoxTopUpAPI, CapturePaypalBcdcOrderParams } from "../../store/service";
import {
  DebitCardActionContent,
  DebitCardRadioContent,
  ForeginQRCodeContainer,
  PaymentWayWrapper,
  RadioPayContainer,
  RechargeBtnContent,
  WechatContent,
} from "./atom";
import { PaySuccessSocket } from "../pay-socket";
import DebitCardIcon from "./debit-card-icon";
import { DebitCardModal } from "./debit-card-modal";
import { Button, Radio } from "@renderbus/ui";
import request from "project-config/services/request/request";
import { payWithPaypal } from "@/components/top-up/help/payWithPaypal";
import { payWithAli } from "@/components/top-up/help/payWithAli";
import { useSearchParams } from "react-router-dom";
import { Space } from "task-eva-ui";
import { useToastStore } from "@/store/toast-store";
import { BalanceTipType, ExtraWelfareTipType } from "../../types";
import { RechargeTips } from "../../help/tips";
import { ExtraTips } from "../extra-tips";
import { BindActivityInfo } from "@/components/top-up/types";
import { CommonTitle } from "../../atom";
import { StripeList, StripeListDev } from "@/constant/StripeList";
import { isDev } from "project-config/utils/env";
import { DataBury } from "renderbus-data-bury";
import {
  DEBIT_CARD_VIEW,
  RechargeViewMode,
  DEFAULT_RECHARGE_VIEW,
} from "../../constants/recharge-view";

export function PaymentWay({
  isShowExtraGift = false,
  activityInfo,
  rechargeViewMode,
  onRechargeViewModeChange,
  style,
}: {
  isShowExtraGift?: boolean;
  activityInfo?: BindActivityInfo;
  rechargeViewMode: RechargeViewMode;
  onRechargeViewModeChange: (mode: RechargeViewMode) => void;
  style?: object;
}) {
  const { userInfo, userLevel, currencySymbol, userCumulative } =
    useGlobalStore();
  const { showGlobalToast } = useToastStore();
  const [isLoading, setIsLoading] = useState(false);
  const [showDebitCardModal, setShowDebitCardModal] = useState(false);
  const [balanceTip, setBalanceTip] = useState<BalanceTipType[]>();
  const [extraTip, setExtraTip] = useState<ExtraWelfareTipType[]>();
  const [currentWechatUrl, setCurrentWechatUrl] = useState("");
  const checkedRadioId = useFoxTopUpStore((state) => state.checkedRadioId);
  const amount = useFoxTopUpStore((state) => state.amount);
  const HangTags = useFoxTopUpStore((state) => state.HangTags);
  const lotteryActivityInfoList = useFoxTopUpStore(
    (state) => state.lotteryActivityInfoList
  );
  const luckDrawGiftActivityInfo = useFoxTopUpStore(
    (state) => state.luckDrawGiftActivityInfo
  );
  const activityInfoList = useFoxTopUpStore((state) => state.activityInfoList);
  const payMethod = useFoxTopUpStore((state) => state.payMethod);
  const verifyRechargeInfo = useFoxTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const verifyRechargeCode = useFoxTopUpStore(
    (state) => state.verifyRechargeCode
  );
  const { couponNO, activityId, rechargeAmount } = verifyRechargeInfo;
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const { t } = useTranslation("topup");
  const { t: centerT } = useTranslation("center");
  const [searchParams] = useSearchParams();
  const currentRadioValue =
    rechargeViewMode === DEBIT_CARD_VIEW ? DEBIT_CARD_VIEW : payMethod;
  const debitRechargeAmount = `${currencySymbol}${amount || 100}`;
  const paypalSandboxBuyerCountry = isDev()
    ? process.env.REACT_APP_PAYPAL_BUYER_COUNTRY || ""
    : "";
  const paypalSandboxCurrency = isDev()
    ? (process.env.REACT_APP_PAYPAL_SANDBOX_CURRENCY || "").toUpperCase()
    : "";
  const debitPaypalSdkCurrency =
    paypalSandboxCurrency ||
    (Number(userInfo?.zone || 2) === 1 ? "CNY" : "USD");
  const debitPaypalCurrencyCode = debitPaypalSdkCurrency === "CNY" ? 1 : 2;
  const rechargeGoal =
    luckDrawGiftActivityInfo || activityInfoList.length
      ? PaymentPurposeCode.ActivityRecharge
      : PaymentPurposeCode.OrdinaryRecharge;

  const createWechatQrcodeURL = async (payRecordId: string) => {
    const { code, data } = await request.post(
      "/api/rendering/pay/payment/createQrcodeURL",
      {
        outTradeNo: payRecordId,
        socketIp: window.location.hostname,
      }
    );
    setIsLoading(false);
    if (code !== 200) return;
    setCurrentWechatUrl(`data:image/png;base64,${data}`);
  };

  const onClickStripeButton = () => {
    const list = isDev() ? StripeListDev : StripeList;
    const card = list.find((item) => item.price === amount);
    const userIdBase36 = userInfo?.userId
      ? Number(userInfo.userId).toString(36)
      : "";
    const url = `${card!.link}?client_reference_id=${userIdBase36}`;
    DataBury.getCustomEventInfo({
      event: "elementClick",
      element: document.getElementById("recharge-button") as HTMLElement,
      extraData: {
        recharge_link: url,
        recharge_amount: amount,
        recharge_type: "stripe支付",
        user_id: userInfo?.userId,
      },
    });
    if (!userInfo?.userId) {
      showGlobalToast({
        type: "error",
        content: t("stripe_not_userid_error"),
      });
      return;
    }

    window.open(url);
  };

  const onClickDebitCardButton = () => {
    setShowDebitCardModal(true);
  };

  const buildRechargeExtraParams = useCallback(async () => {
    if (isShowExtraGift && !checkedRadioId) {
      showGlobalToast({
        type: "error",
        content: t("fox_extra_welfare_tip"),
      });
      return null;
    }

    let extraParams = {} as Record<string, any>;
    if (isShowExtraGift && checkedRadioId) {
      extraParams = {
        ...extraParams,
        activityDetailId: checkedRadioId,
      };
    }

    if (couponNO && Number(amount) >= rechargeAmount) {
      const { code } = await verifyRechargeCode({
        couponNO,
        amount: Number(amount),
      });
      if (code !== 200) {
        setFoxTopUpStore({
          verifyRechargeInfo: initVerifyRechargeInfo,
        });
        showGlobalToast({
          type: "error",
          content: t(`fox_coupon_code_tips_${code}`),
        });
        return null;
      }

      extraParams = {
        ...extraParams,
        couponNo: couponNO,
        couponActivityId: activityId,
      };
    }

    return extraParams;
  }, [
    activityId,
    amount,
    checkedRadioId,
    couponNO,
    isShowExtraGift,
    rechargeAmount,
    setFoxTopUpStore,
    showGlobalToast,
    t,
    verifyRechargeCode,
  ]);

  const createDebitCardOrder = useCallback(async () => {
    const extraParams = await buildRechargeExtraParams();
    if (!extraParams) {
      throw new Error("Debit card payment prerequisites are not satisfied.");
    }

    let agent = searchParams.get("agent") || "";
    const { code, data, message } = await FoxTopUpAPI.createPaypalBcdcOrder({
      amount: Number(amount),
      currency: debitPaypalCurrencyCode,
      agent: agent || "",
      socketIp: window.location.hostname,
      presentType: 0,
      rechargeGoal,
      rechargeChannels: rechargeChannelsCode.Web,
      ...extraParams,
    });

    if (code !== 200 || !data?.payRecordId || !data?.paypalOrderId) {
      throw new Error(message || "Failed to create the PayPal BCDC order.");
    }

    return {
      payRecordId: data.payRecordId,
      paypalOrderId: data.paypalOrderId,
    };
  }, [
    amount,
    buildRechargeExtraParams,
    debitPaypalCurrencyCode,
    rechargeGoal,
    searchParams,
  ]);

  const captureDebitCardOrder = useCallback(
    async (payload: CapturePaypalBcdcOrderParams) => {
      const { code, data, message } = await FoxTopUpAPI.capturePaypalBcdcOrder(
        payload
      );

      if (code !== 200) {
        throw new Error(message || "Failed to capture the PayPal BCDC order.");
      }

      return data || {};
    },
    []
  );

  const closeDebitCardModal = useCallback(() => {
    setShowDebitCardModal(false);
  }, []);

  const handleDebitCardPaymentSuccess = useCallback(() => {
    showGlobalToast({
      type: "success",
      content: "PayPal BCDC payment completed successfully.",
    });
  }, [showGlobalToast]);

  const onClickRechargeButton = async () => {
    if (payMethod === PaymentTypeCode.Stripe) {
      onClickStripeButton();
      return;
    }
    const extraParams = await buildRechargeExtraParams();
    if (!extraParams) {
      return;
    }

    setIsLoading(true);
    let agent = searchParams.get("agent") || "";
    let params = {
      agent: agent || "",
      currency: userInfo?.zone,
      payMethod,
      amount: Number(amount),
      // todo
      // socketIp: sessionStorage.getItem(STORAGE.PUSH_INFORMATION) || "", // if has socket connect
      rechargeGoal,
      rechargeChannels: rechargeChannelsCode.Web,
    } as any;
    params = {
      ...params,
      ...extraParams,
    };

    const { code, data } = await request.post(
      "/api/rendering/pay/recharge/addPayRecord",
      params
    );
    setIsLoading(false);
    if (code !== 200) {
      return;
    }
    switch (payMethod) {
      case PaymentTypeCode.Paypal:
        payWithPaypal(data.params, () => "todo modal");
        break;
      case PaymentTypeCode.Alipay:
        payWithAli(data.params, () => "todo modal");
        break;
      case PaymentTypeCode.Wechat:
        setIsLoading(true);
        createWechatQrcodeURL(data.payRecordId);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setCurrentWechatUrl("");
  }, [amount]);

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(amount),
      userLevel,
      userCumulative,
      currencySymbol,
      verifyRechargeInfo,
      HangTags,
      activityInfo,
      luckDrawGiftActivityInfo,
      lotteryActivityInfoList,
      checkedRadioId,
    });
    void rechargeTips.init();
    setBalanceTip(rechargeTips.balanceTip);
    setExtraTip(rechargeTips.extraWelfareTip);
  }, [
    amount,
    userLevel,
    userCumulative,
    currencySymbol,
    verifyRechargeInfo,
    HangTags,
    activityInfo,
    luckDrawGiftActivityInfo,
    lotteryActivityInfoList,
    checkedRadioId,
  ]);

  return (
    <PaymentWayWrapper style={style}>
      <PaySuccessSocket />
      <CommonTitle>{t("fox_payment_text")}</CommonTitle>
      <ExtraTips balanceTip={balanceTip} extraTip={extraTip} />
      <RadioPayContainer>
        <Radio.Group
          onChange={(e) => {
            if (e.target.value === DEBIT_CARD_VIEW) {
              onRechargeViewModeChange(DEBIT_CARD_VIEW);
              return;
            }

            onRechargeViewModeChange(DEFAULT_RECHARGE_VIEW);
            setFoxTopUpStore((state) => {
              state.payMethod = e.target.value;
            });
          }}
          value={currentRadioValue}
          className="pay-radio"
        >
          <Space align="center" gap="44">
            <Space direction="column" gap="14">
              <Radio value={DEBIT_CARD_VIEW} className="debit-card-radio">
                <DebitCardRadioContent>
                  <DebitCardIcon />
                  <span className="entry-text">
                    {t("fox_debit_card_title")}
                  </span>
                </DebitCardRadioContent>
              </Radio>
              <Radio className="paypal-box" value={PaymentTypeCode.Paypal}>
                <div className="paypal-label">
                  <img src={Paypal} alt="" className="payment-icon" />
                  <span className="pay-text">
                    {centerT("pay_method_paypal")}
                  </span>
                </div>
                <div className="card-icons">
                  <img src={Pay01} alt="" className="pay-icon" />
                  <img src={Pay02} alt="" className="pay-icon" />
                  <img src={Pay03} alt="" className="pay-icon" />
                  <img src={Pay04} alt="" className="pay-icon" />
                  <img src={Pay05} alt="" className="pay-icon" />
                  <img src={Pay06} alt="" className="pay-icon" />
                </div>
              </Radio>
              <Radio className="stripe-box" value={PaymentTypeCode.Stripe}>
                <div className="flex">
                  <img src={Stripe} alt="" className="payment-icon" />
                  <span className="pay-text">
                    {centerT("topUP_stripe_support")}
                  </span>
                  <span className="recommended">{t("stripe_recommended")}</span>
                </div>
                <div>
                  <img src={Pay01} alt="" className="pay-icon" />
                  <img src={Pay02} alt="" className="pay-icon" />
                  <img src={Pay03} alt="" className="pay-icon" />
                  <img src={Pay04} alt="" className="pay-icon" />
                </div>
              </Radio>
              <Radio value={PaymentTypeCode.Alipay}>
                <img src={Alipay} alt="" className="payment-icon" />
                <span className="pay-text">
                  {centerT("topUP_alipay_support")}
                </span>
              </Radio>
              <Radio value={PaymentTypeCode.Wechat}>
                <img src={Wechat} alt="" className="payment-icon" />
                <span className="pay-text">
                  {centerT("topUP_wechat_support")}
                </span>
              </Radio>
            </Space>
            <RechargeBtnContent>
              {rechargeViewMode === DEBIT_CARD_VIEW ? (
                <DebitCardActionContent>
                  <p className="title">{t("fox_debit_card_pay_title")}</p>
                  <Button
                    className="recharge-button"
                    onClick={onClickDebitCardButton}
                  >
                    {t("recharge_recharge_btn")}
                  </Button>
                </DebitCardActionContent>
              ) : payMethod === PaymentTypeCode.Wechat && currentWechatUrl ? (
                <WechatContent>
                  <ForeginQRCodeContainer>
                    <img src={currentWechatUrl} alt="" />
                  </ForeginQRCodeContainer>
                  <div>
                    <p className="scan-text">{t("fox_scan_qrcode")}</p>
                    <Button
                      className="recharge-button wechat-recharge"
                      onClick={onClickRechargeButton}
                      loading={isLoading}
                    >
                      {t("recharge_recharge_btn")}
                    </Button>
                  </div>
                </WechatContent>
              ) : (
                <>
                  <p className="title">{t(`topup_fox_pay_${payMethod}`)}</p>
                  <p
                    style={
                      payMethod === PaymentTypeCode.Stripe
                        ? { color: "#f3512b" }
                        : { color: "#d4d4d4" }
                    }
                  >
                    {t(`topup_fox_pay_tip_${payMethod}`)}
                  </p>
                  <Button
                    id="recharge-button"
                    className={`recharge-button`}
                    onClick={onClickRechargeButton}
                    loading={isLoading}
                  >
                    {t("recharge_recharge_btn")}
                  </Button>
                </>
              )}
            </RechargeBtnContent>
          </Space>
        </Radio.Group>
      </RadioPayContainer>
      <DebitCardModal
        open={showDebitCardModal}
        rechargeAmount={debitRechargeAmount}
        onClose={closeDebitCardModal}
        paypalBuyerCountry={paypalSandboxBuyerCountry}
        paypalCurrency={debitPaypalSdkCurrency}
        createOrder={createDebitCardOrder}
        captureOrder={captureDebitCardOrder}
        onPaymentSuccess={handleDebitCardPaymentSuccess}
      />
    </PaymentWayWrapper>
  );
}
